import React, { useEffect, useState } from "react";
import {
	HeaderAndBodyLayout,
	PageTitle,
	SectionDivider,
} from "../../../utilities/dcgAutomationPageCommonImports";
import dcgLogo from "../../../assets/img/brand/dcg_logo_header.png";
import { DefaultRegionStorageKey } from '../../../constants/localStorage';
import DefaultRegion from "../../../components/DefaultRegion/DefaultRegion";
import { Button, Container } from "reactstrap";
import { useAPIContext } from "../../../utilities/Contexts/DCGAutomationPagesContextProvider";

function DefaultRegionPage() {
	const {navigateToPage} = useAPIContext();
	const [isValid, setIsValid] = useState(false);

    const [manageData, setData] = useState(() => {
        const manageData = parseInt(localStorage.getItem(DefaultRegionStorageKey)) ?? 0;

        return manageData;
    });

    useEffect(() => {
        if (manageData) {
            localStorage.setItem(DefaultRegionStorageKey, manageData);

			setIsValid(manageData > 0);
        }

    }, [manageData]);

	function handleSelected(value){
		setData(value);
		setIsValid(value > 0);
	}

	function navigateToNext(e){
        if (isValid) {
            navigateToPage('portalAdminInfo');
        }
	}

	return (
		<>
			<HeaderAndBodyLayout headerLogo={dcgLogo}>
				<PageTitle heading="Please choose your country" subheading="" />
				<SectionDivider width="70%" />
				<DefaultRegion handleSelected={handleSelected} defaultValue={manageData} />
				<Container className="text-center">
                	<Button onClick={navigateToNext} color="primary" disabled={!isValid}>NEXT</Button>
            	</Container>
			</HeaderAndBodyLayout>
		</>
	)
};

export default DefaultRegionPage;
